import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const NotificationCenter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, title: "Anomalous Spend Detected", type: "alert", time: "2m ago", read: false },
    { id: 2, title: "New Benchmark Data Available", type: "info", time: "1h ago", read: false },
    { id: 3, title: "Q3 Audit Finalized", type: "success", time: "3h ago", read: true }
  ]);

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="relative">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 text-slate-400 hover:text-brand-cyan transition-colors bg-white/5 rounded-lg border border-white/10"
      >
        <SafeIcon name="Bell" className="w-5 h-5" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-brand-red text-[10px] font-black flex items-center justify-center rounded-full text-white animate-pulse">
            {unreadCount}
          </span>
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
            <motion.div 
              initial={{ opacity: 0, y: 10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.95 }}
              className="absolute right-0 mt-4 w-80 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-2xl z-50 overflow-hidden"
            >
              <div className="p-4 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-slate-50 dark:bg-slate-900/50">
                <h4 className="text-xs font-black uppercase tracking-widest text-slate-900 dark:text-white">Strategic Alerts</h4>
                <button className="text-[10px] uppercase font-bold text-brand-cyan">Clear All</button>
              </div>
              <div className="max-h-96 overflow-y-auto custom-scrollbar">
                {notifications.map((n) => (
                  <div key={n.id} className={`p-4 border-b border-slate-50 dark:border-slate-800/50 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors cursor-pointer ${!n.read ? 'bg-brand-cyan/5' : ''}`}>
                    <div className="flex gap-3">
                      <div className={`mt-1 w-2 h-2 rounded-full shrink-0 ${n.type === 'alert' ? 'bg-brand-red' : n.type === 'success' ? 'bg-green-500' : 'bg-brand-cyan'}`} />
                      <div>
                        <p className="text-sm font-bold text-slate-900 dark:text-white leading-tight mb-1">{n.title}</p>
                        <p className="text-[10px] text-slate-500 font-medium">{n.time}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="p-3 text-center border-t border-slate-100 dark:border-slate-800">
                <button className="text-[10px] uppercase font-bold text-slate-400 hover:text-brand-cyan transition-colors">View All Notifications</button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NotificationCenter;